var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKaz = function SvgKaz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M352 265.768H160c0 13.255 11.544 23.999 24.799 23.999H184c0 13.255 10.744 24.001 24.001 24.001 0 13.255 10.744 24.001 24.001 24.001h48c13.255 0 24.001-10.744 24.001-24.001 13.255 0 24.001-10.744 24.001-24.001h-.799c13.249 0 24.795-10.744 24.795-23.999z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M322.462 234.384c0 36.705-29.756 66.462-66.462 66.462s-66.462-29.756-66.462-66.462"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M321.882 228.163l-26.92 10.899 14.335 22.441-29.232-4.814-3.704 25.415L256 263.412l-20.362 18.692-3.703-25.415-29.232 4.812 14.334-22.44-26.919-10.898 26.92-10.899-14.335-22.439 29.231 4.813 3.705-25.417L256 192.915l20.362-18.694 3.703 25.417 29.233-4.813-14.335 22.44z"
  })));
};
export { SvgKaz as ReactComponent };